import { createSelector } from "reselect";

export const initialScrapeTaskBatchStartsEntriesSelector = createSelector(
    state => state.initialScrapeTaskBatchStarts.entries,
    state => state
);

export const initialScrapeTaskBatchStartDialogSelector = createSelector(
    state => state.initialScrapeTaskBatchStarts.entries.initialScrapeTaskBatchStartDialog,
    state => state
);
export const downloadDialogSelector = createSelector(
    state => state.initialScrapeTaskBatchStarts.entries.downloadDialog,
    state => state
);
